import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideSectionLabel,
  GuideBlockList,
} from "../GuideBlocks.js";

const EmotionalTriggersSection = ({ heading, accentIndex = 0, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="emotional-triggers"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      An emotional trigger is anything that creates a strong emotional reaction. The trigger itself
      is not always the real problem. Often, it activates an older emotional experience.
    </GuideLead>
    <p className="guide-panel__p">
      Someone interrupts you during a meeting. The interruption lasts only a few seconds. But your
      emotional reaction feels much bigger. Why? Perhaps you have previously felt ignored, dismissed,
      or undervalued. The current situation activates that earlier experience.
    </p>
    <GuideSectionLabel>Common emotional triggers</GuideSectionLabel>
    <GuideBlockList
      items={[
        "Criticism",
        "Rejection",
        "Feeling ignored",
        "Failure",
        "Uncertainty",
        "Being misunderstood",
        "Loss of control",
        "Conflict",
        "Comparison",
        "Unmet expectations",
      ]}
    />
    <p className="guide-panel__p">
      When a trigger fires, the fastest way back to clear thinking is to separate the event from the
      interpretation. The event: "I was interrupted." The interpretation: "They don't value my input."
      The event is a fact; the interpretation is a hypothesis. Once they are separated, you can ask
      what evidence actually supports the interpretation — and choose a response based on that answer
      instead of the older experience the trigger reactivated.
    </p>
    <GuideCallout variant="amber">
      Instead of asking, "Why did they make me angry?" ask, "What inside me reacted so strongly?"
      That question creates self-awareness.
    </GuideCallout>
  </GuidePanel>
);

export default EmotionalTriggersSection;
